import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { MINT_MIST } from '../../constants/brandSurfaces';

const blue = '#0d4efe';
const teal = '#01ebb2';
const ink = '#1a1a2e';
const muted = '#5a6478';

export const PricingPanel = styled('section')({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 420px)',
  alignItems: 'center',
  gap: 40,
  marginTop: 40,
  padding: '44px 48px',
  borderRadius: 24,
  background: MINT_MIST,
  border: '1px solid rgba(26, 26, 46, 0.06)',
  textAlign: 'left',
  '@media (max-width: 900px)': {
    gridTemplateColumns: '1fr',
    gap: 24,
    padding: '32px 28px',
  },
  '@media (max-width: 600px)': {
    marginTop: 28,
    padding: '26px 16px',
    borderRadius: 16,
  },
});

export const Eyebrow = styled('p')({
  margin: '0 0 8px',
  fontSize: '0.95rem',
  fontWeight: 700,
  color: blue,
});

export const Title = styled('h2')({
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  fontSize: '1.75rem',
  fontWeight: 700,
  lineHeight: 1.2,
  letterSpacing: '-0.02em',
  color: ink,
  margin: '0 0 10px',
  '@media (max-width: 600px)': {
    fontSize: '1.4rem',
  },
});

export const IntroText = styled('p')({
  fontSize: '1rem',
  lineHeight: 1.6,
  color: muted,
  margin: 0,
  maxWidth: 460,
});

export const OfferLine = styled('p')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  width: 'fit-content',
  margin: '20px auto 0',
  padding: '8px 14px',
  borderRadius: 999,
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  fontSize: '0.98rem',
  fontWeight: 800,
  lineHeight: 1.2,
  color: '#047857',
  background: 'rgba(1, 235, 178, 0.16)',
  border: '1px solid rgba(1, 235, 178, 0.4)',
  '& svg': { fontSize: 20 },
});

export const PlanCard = styled('div')({
  padding: 24,
  borderRadius: 20,
  background: '#ffffff',
  border: '1px solid rgba(26, 26, 46, 0.06)',
  boxShadow: '0 8px 28px rgba(26, 26, 46, 0.08)',
  '@media (max-width: 600px)': {
    padding: 20,
  },
});

export const PlanName = styled('h3')({
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  fontSize: '1.15rem',
  fontWeight: 700,
  color: ink,
  margin: '0 0 8px',
});

export const PriceRow = styled('p')({
  display: 'flex',
  alignItems: 'baseline',
  gap: 6,
  margin: '0 0 4px',
});

export const PriceAmount = styled('span')({
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  fontSize: '2.5rem',
  fontWeight: 800,
  letterSpacing: '-0.03em',
  lineHeight: 1,
  color: ink,
});

export const PricePeriod = styled('span')({
  fontSize: '0.95rem',
  color: muted,
});

export const PriceNote = styled('p')({
  fontSize: '0.88rem',
  color: muted,
  margin: '0 0 16px',
});

export const FeatureList = styled('ul')({
  listStyle: 'none',
  margin: 0,
  padding: '16px 0 0',
  borderTop: '1px solid rgba(26, 26, 46, 0.08)',
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
});

export const FeatureRow = styled('li')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
});

export const FeatureIcon = styled('span')({
  flex: '0 0 auto',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  borderRadius: '50%',
  color: blue,
  background: 'rgba(1, 235, 178, 0.18)',
  '& svg': { fontSize: 18 },
});

export const FeatureLabel = styled('span')({
  display: 'block',
  fontSize: '0.95rem',
  fontWeight: 700,
  color: ink,
  lineHeight: 1.3,
});

export const FeatureDesc = styled('span')({
  display: 'block',
  fontSize: '0.86rem',
  color: muted,
  lineHeight: 1.4,
});

export const PrimaryCta = styled(Button)({
  width: '100%',
  marginTop: 14,
  textTransform: 'none',
  borderRadius: 10,
  padding: '11px 24px',
  fontSize: '1rem',
  fontWeight: 700,
  color: '#ffffff',
  background: `linear-gradient(90deg, ${teal} 0%, ${blue} 100%)`,
  boxShadow: '0 4px 14px rgba(13, 78, 254, 0.35)',
  '&:hover': {
    color: '#ffffff',
    background: `linear-gradient(90deg, ${teal} 0%, ${blue} 100%)`,
    filter: 'brightness(1.05)',
    boxShadow: '0 6px 18px rgba(13, 78, 254, 0.4)',
  },
});

export const SecondaryCta = styled(Button)({
  width: '100%',
  marginTop: 10,
  textTransform: 'none',
  borderRadius: 10,
  padding: '10px 20px',
  fontSize: '0.95rem',
  fontWeight: 600,
  color: ink,
  border: '1px solid rgba(26, 26, 46, 0.16)',
  background: '#ffffff',
  '&:hover': {
    background: '#ffffff',
    borderColor: blue,
    color: blue,
  },
});

export const Disclaimer = styled('p')({
  textAlign: 'center',
  fontSize: '0.8rem',
  color: muted,
  margin: '10px 0 0',
});
